import { AttachmentFile, SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountAttachmentsQueryKey } from "./account.keys";

export const useFetchAccountAttachments = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();

	const isAdmin = user.type === "admin";

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountAttachmentsQueryKey(accountId),
		queryFn: async () => {
			const url = isAdmin
				? `/v2/admin/surety/accounts/${accountId}/attachments`
				: `/v2/surety/accounts/${accountId}/attachments`;
			return await get<AttachmentFile[]>(url);
		},
	});

	return {
		attachments: data ?? [],
		attachmentsError: error,
		attachmentsIsLoading: isLoading,
		refetchAccountAttachments: refetch,
	};
};
